import { combineReducers } from 'redux'
import app from './app'
import navbar from './navbar'
import listReducer from './list'

export default combineReducers({ app, navbar, teacher:listReducer("teacher"), texts:listReducer("texts"), images:listReducer("images"), imagesData:listReducer("imagesData")});

  
  
